import { render, staticRenderFns } from "./SegmentQuestion.vue?vue&type=template&id=6a557e3a&scoped=true&"
import script from "./SegmentQuestion.vue?vue&type=script&lang=js&"
export * from "./SegmentQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SegmentQuestion.vue?vue&type=style&index=0&id=6a557e3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a557e3a",
  null
  
)

export default component.exports